import useSetFetchedChoices from "../../../common/choices/useSetFetchedChoices";
import { checkboxesChoicesType } from "../../../common/types/search/search";

interface SetFetchedChoicesInitializerProps {
	criterionKey: string;
	criterionLabel: string;
	criterionChoices?: checkboxesChoicesType;
}

export const SetFetchedChoicesInitializer = ({
	criterionKey,
	criterionLabel,
	criterionChoices,
}: SetFetchedChoicesInitializerProps) => {
	useSetFetchedChoices(criterionKey, criterionLabel, criterionChoices);

	return null;
};
